import Floorbed1Svelte from "./Floorbed1.svelte";
const initConfig = {
    mainTitle: "Customize your Accora Floorbed 1",
    bookADemoHref: "https://accora.care/book-a-join-visit",
};
export const AccoraFloorbedOne = (targetId, config) => {
    const app = new Floorbed1Svelte({
        target: document.getElementById(targetId),
        props: {
            config: Object.assign(Object.assign({}, initConfig), config),
        },
    });
    return app;
};
window.AccoraFloorbedOne = AccoraFloorbedOne;
export default AccoraFloorbedOne;
